import Link from 'next/link';
import { FormattedMessage } from 'react-intl';
import CloseIcon from '@mui/icons-material/Close';

export type NotificationTileAplProps = {
    accBlocked?: boolean;
    licenseExpCount?: number | null;
    handleClose: () => void;
}

export default function NotificationTileApl({ accBlocked, licenseExpCount, handleClose }: NotificationTileAplProps) {
    return (
        <div className={` hidden lg:flex justify-center ${accBlocked ? 'bg-[#F5DBB5]' : 'bg-[#FAC4C4]'} `}>
                <div className='w-4/5 2xl:w-full justify-between flex items-center py-[7px] px-4 md:px-6 lg:px-[108px] '>
                    <p className='text-darkGreen text-left font-semibold text-xs leading-[18px]'>
                        {accBlocked ? (
                            <FormattedMessage id='TopNotice.content.expirationTxt' />
                        ) : (
                            licenseExpCount && <FormattedMessage id='TopNotice.content.expirationTxt2' />
                        )}
                    </p>
                    {!accBlocked && (
                        <div className='flex items-center min-w-[20%] whitespace-nowrap 2xl:min-w-0 ml-[50px]'>
                            <Link href={'/my-account/Settings'} legacyBehavior>
                                <a className='text-darkGreen font-bold underline text-xs cursor-pointer mr-5 text-center'>
                                    <FormattedMessage id='TopNotice.viewLic' />
                                </a>
                            </Link>
                            <CloseIcon data-testid='close-icon' sx={{color: '#234455'}} className='cursor-pointer' onClick={() => handleClose()}/>
                        </div>
                    )}
                </div>
            </div>
    );
}
